













import {Vue,Component,Prop, Watch,Mixins} from 'vue-property-decorator';
import BookmarkMixin from './BookmarkMixin';
@Component
export default  class  IntegerBookmark extends Mixins(BookmarkMixin){
    created(){
        
        this.value = 0;
        if(this.defaultValue){
            this.value = parseInt(this.defaultValue);
        }

        //console.log(this.englishName + "=>" + this.isVisible);
        
    }
    focusOut(){
        this.value = parseInt(this.value);
        this.$emit("value-changed",this.englishName);
    }

    onValueChanged(newVal: any, oldVal: any){
        if(!isNaN(newVal))
            this.value = parseInt(newVal);
        //console.log(this.englishName + ">>>" + this.value);
    }

}
